var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _circle, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendlePtReth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3525_869)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3525_869",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 250,
    height: 250
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250 0H0V250H250V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3525_869)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125 250C194.035 250 250 194.035 250 125C250 55.9646 194.035 0 125 0C55.9646 0 0 55.9646 0 125C0 194.035 55.9646 250 125 250Z",
    fill: "url(#paint0_radial_3525_869)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3525_869",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 250,
    height: 250
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125 250C194.035 250 250 194.035 250 125C250 55.9646 194.035 0 125 0C55.9646 0 0 55.9646 0 125C0 194.035 55.9646 250 125 250Z",
    fill: "url(#paint1_radial_3525_869)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3525_869)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-4.16699 68.75C-4.16699 65.9887 -1.92842 63.75 0.833008 63.75H69.1663C71.9276 63.75 74.1663 65.9887 74.1663 68.75V185C74.1663 187.761 71.9276 190 69.1663 190H0.833008C-1.92842 190 -4.16699 187.761 -4.16699 185V68.75Z",
    fill: "url(#paint2_linear_3525_869)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M150.833 169.584C150.833 166.823 153.072 164.584 155.833 164.584H245C247.761 164.584 250 166.823 250 169.584V212.917C250 215.679 247.761 217.917 245 217.917H155.833C153.072 217.917 150.833 215.679 150.833 212.917V169.584Z",
    fill: "#E74310"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M208.75 182.918C211.511 182.918 213.75 185.157 213.75 187.918V272.085C213.75 274.846 211.511 277.085 208.75 277.085H175.833C173.072 277.085 170.833 274.846 170.833 272.085V187.918C170.833 185.157 173.072 182.918 175.833 182.918H208.75Z",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101.25 81.25C104.011 81.25 106.25 83.4888 106.25 86.25V153.333C106.25 156.095 104.011 158.333 101.25 158.333H64.1665C61.4053 158.333 59.1665 156.095 59.1665 153.333V86.25C59.1665 83.4888 61.4053 81.25 64.1665 81.25H101.25Z",
    fill: "url(#paint3_linear_3525_869)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.75 101.25C23.75 98.4887 25.9886 96.25 28.75 96.25H89.5833C92.3446 96.25 94.5833 98.4887 94.5833 101.25V165C94.5833 167.761 92.3446 170 89.5833 170H28.75C25.9886 170 23.75 167.761 23.75 165V101.25Z",
    fill: "url(#paint4_linear_3525_869)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M250 34.168C252.761 34.168 255 36.4066 255 39.168V123.335C255 126.096 252.761 128.335 250 128.335H172.5C169.739 128.335 167.5 126.096 167.5 123.335V39.168C167.5 36.4066 169.739 34.168 172.5 34.168H250Z",
    fill: "#FF9776"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M202.916 -21.666C205.678 -21.666 207.916 -19.4274 207.916 -16.666V75.834C207.916 78.5952 205.678 80.834 202.916 80.834H159.583C156.822 80.834 154.583 78.5952 154.583 75.834V-16.666C154.583 -19.4274 156.822 -21.666 159.583 -21.666H202.916Z",
    fill: "#FFCA8C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M225.417 -5C228.178 -5 230.417 -2.76142 230.417 4.76837e-06V102.917C230.417 105.678 228.178 107.917 225.417 107.917H131.25C128.489 107.917 126.25 105.678 126.25 102.917V2.86102e-06C126.25 -2.76142 128.489 -5 131.25 -5H225.417Z",
    fill: "url(#paint5_linear_3525_869)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M88.3332 -34.166C91.0944 -34.166 93.3332 -31.9274 93.3332 -29.166V40.0006C93.3332 42.7619 91.0944 45.0006 88.3332 45.0006H55.4165C52.6553 45.0006 50.4165 42.7619 50.4165 40.0006V-29.166C50.4165 -31.9274 52.6553 -34.166 55.4165 -34.166H88.3332Z",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M92.083 180.418C94.8443 180.418 97.083 182.657 97.083 185.418V245.001C97.083 247.763 94.8443 250.001 92.083 250.001H8.33301C5.57159 250.001 3.33301 247.763 3.33301 245.001L3.33301 185.418C3.33301 182.657 5.57159 180.418 8.33301 180.418H92.083Z",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M165.833 147.084C168.595 147.084 170.833 149.323 170.833 152.084V245.001C170.833 247.762 168.595 250.001 165.833 250.001H70C67.2387 250.001 65 247.762 65 245.001V152.084C65 149.323 67.2387 147.084 70 147.084H165.833Z",
    fill: "#FFD494"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.167 4.37113e-06C136.928 4.49183e-06 139.167 2.23858 139.167 5V29.1667C139.167 31.9281 136.928 34.1667 134.167 34.1667H34.1665C31.4051 34.1667 29.1665 31.9281 29.1665 29.1667V5C29.1665 2.23858 31.4051 -1.20706e-07 34.1665 0L134.167 4.37113e-06Z",
    fill: "#FFD494"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M55.3118 247.566L242.565 60.3125L236.143 53.8904L48.8896 241.144L55.3118 247.566Z",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.2649 233.935L228.519 46.6816L220.157 38.3203L32.9035 225.574L41.2649 233.935Z",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M33.3611 225.199L220.615 37.9453L212.253 29.5839L24.9997 216.838L33.3611 225.199Z",
    fill: "#F45C2C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.8611 216.033L213.115 28.7793L206.233 21.8977L18.9795 209.151L25.8611 216.033Z",
    fill: "#F45C2C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.9651 209.136L206.219 21.8828L199.337 15.0012L12.0835 202.255L18.9651 209.136Z",
    fill: "#FFBC6E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.3816 199.969L201.635 12.7148L194.754 5.83322L7.49996 193.087L14.3816 199.969Z",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M-7.70204 144.97L139.949 -2.68164L133.068 -9.56326L-14.5837 138.088L-7.70204 144.97Z",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M-15.6185 136.616L132.033 -11.0352L125.151 -17.9168L-22.5002 129.734L-15.6185 136.616Z",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M-22.702 127.034L124.949 -20.6172L118.068 -27.4988L-29.5837 120.152L-22.702 127.034Z",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.9645 165.037L175.453 -6.45117L168.571 -13.3328L-2.91713 158.155L3.9645 165.037Z",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.54799 175.871L180.036 4.38281L173.155 -2.49881L1.66637 168.989L8.54799 175.871Z",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1.04831 152.469L153.25 0.267578L146.368 -6.61404L-5.83331 145.587L1.04831 152.469Z",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M55.0354 247.707L242.289 60.4531L228.56 46.7239L41.3062 233.978L55.0354 247.707Z",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M55.0354 247.707L242.289 60.4531L228.49 46.654L41.2363 233.908L55.0354 247.707Z",
    fill: "#DF3600"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.815 151.972L77.2573 123.839L124.815 44.9453L172.331 123.839L124.815 151.972Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.815 199.871L77.2573 132.889L124.815 160.98L172.374 132.889L124.815 199.871Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196 250C225.823 250 250 225.823 250 196C250 166.177 225.823 142 196 142C166.177 142 142 166.177 142 196C142 225.823 166.177 250 196 250Z",
    fill: "#131517"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3525_869",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 142,
    width: 109,
    height: 108
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.81 250C225.633 250 249.81 225.823 249.81 196C249.81 166.177 225.633 142 195.81 142C165.986 142 141.81 166.177 141.81 196C141.81 225.823 165.986 250 195.81 250Z",
    fill: "#131517"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3525_869)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M171.516 276.997C187.923 276.997 201.224 263.696 201.224 247.289C201.224 230.882 187.923 217.582 171.516 217.582C155.11 217.582 141.809 230.882 141.809 247.289C141.809 263.696 155.11 276.997 171.516 276.997Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3525_869",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 145,
    width: 7,
    height: 80
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.249 224.678V145.062H174.871V224.678H168.249Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3525_869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.81 196C249.81 225.824 225.633 250 195.81 250C165.986 250 141.81 225.824 141.81 196C141.81 166.177 165.986 142 195.81 142C225.633 142 249.81 166.177 249.81 196Z",
    fill: "white"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 54,
    r: 54,
    fill: "#D5EBFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M181.787 35.239C184.227 35.239 186.382 35.788 188.253 36.886C190.164 37.984 191.628 39.5293 192.645 41.522C193.702 43.5147 194.231 45.792 194.231 48.354C194.231 50.8753 193.702 53.112 192.645 55.064C191.628 56.9753 190.164 58.4597 188.253 59.517C186.382 60.5743 184.227 61.103 181.787 61.103H175.199C174.995 61.103 174.894 61.2047 174.894 61.408V77.268C174.894 77.4713 174.812 77.6543 174.65 77.817C174.528 77.939 174.365 78 174.162 78H167.025C166.821 78 166.638 77.939 166.476 77.817C166.354 77.6543 166.293 77.4713 166.293 77.268V35.971C166.293 35.7677 166.354 35.605 166.476 35.483C166.638 35.3203 166.821 35.239 167.025 35.239H181.787ZM180.384 54.271C181.97 54.271 183.23 53.7627 184.166 52.746C185.142 51.6887 185.63 50.2857 185.63 48.537C185.63 46.7477 185.142 45.3243 184.166 44.267C183.23 43.2097 181.97 42.681 180.384 42.681H175.199C174.995 42.681 174.894 42.7827 174.894 42.986V53.966C174.894 54.1693 174.995 54.271 175.199 54.271H180.384ZM225.417 35.3C225.62 35.3 225.783 35.3813 225.905 35.544C226.068 35.666 226.149 35.8287 226.149 36.032V42.01C226.149 42.2133 226.068 42.3963 225.905 42.559C225.783 42.681 225.62 42.742 225.417 42.742H216.145C215.942 42.742 215.84 42.8437 215.84 43.047V77.268C215.84 77.4713 215.759 77.6543 215.596 77.817C215.474 77.939 215.311 78 215.108 78H207.971C207.768 78 207.585 77.939 207.422 77.817C207.3 77.6543 207.239 77.4713 207.239 77.268V43.047C207.239 42.8437 207.137 42.742 206.934 42.742H197.967C197.764 42.742 197.581 42.681 197.418 42.559C197.296 42.3963 197.235 42.2133 197.235 42.01V36.032C197.235 35.8287 197.296 35.666 197.418 35.544C197.581 35.3813 197.764 35.3 197.967 35.3H225.417Z",
    fill: "#1C293A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3525_869",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.6667 59.7917) rotate(54.1675) scale(207.118)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED5A37"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3525_869",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.6667 59.7917) rotate(54.1675) scale(207.118)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED5A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3525_869",
    x1: 34.9997,
    y1: 63.75,
    x2: 34.9997,
    y2: 190,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE090",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3525_869",
    x1: 82.4998,
    y1: 81.25,
    x2: 82.4998,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF3600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF3600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3525_869",
    x1: 23.75,
    y1: 133.451,
    x2: 89.2229,
    y2: 133.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF3600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF3600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3525_869",
    x1: 178.333,
    y1: -5,
    x2: 178.333,
    y2: 107.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF3600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF3600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3525_869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendlePtReth);
export default __webpack_public_path__ + "static/media/pendle-pt-reth.ec54594ffed183b8682c529e525a4396.svg";
export { ForwardRef as ReactComponent };